import type { DouyinImFlowResultStatus } from '../enums/douyinImFlowStatus';
import type { DouyinImTaskKind, DouyinImTaskStatus } from '../enums/douyinImTaskQueue';
import type { DouyinImTaskRuntimeStage } from '../enums/douyinImTaskRuntimeStage';

export interface DouyinImTaskQueueItem {
  taskKey: string;
  taskKind: DouyinImTaskKind;
  appUserId: string;
  entityId: string;
  ecomAccountId: string;
  targetUrl: string;
  message: string;
  replyContentJson?: string;
  status: DouyinImTaskStatus;
  browserStage?: DouyinImTaskRuntimeStage;
  resultSuccess: boolean;
  resultStatus?: DouyinImFlowResultStatus;
  failureReason: string;
  syncErrorMessage: string;
  createdAt: number;
  updatedAt: number;
}

export type DouyinImTaskQueueMap = Record<string, DouyinImTaskQueueItem>;

export function buildDouyinImTaskKey(taskKind: DouyinImTaskKind, entityId: string | number) {
  return `${taskKind}:${String(entityId).trim()}`;
}

export function buildLeadDouyinImTaskKey(leadId: string | number) {
  return buildDouyinImTaskKey('PUBLIC_LEAD', leadId);
}

export function buildImSessionDouyinImTaskKey(imSessionId: string) {
  return buildDouyinImTaskKey('IM_SESSION', imSessionId);
}

export function buildPrivateCommentLeadDouyinImTaskKey(leadId: string) {
  return buildDouyinImTaskKey('PRIVATE_COMMENT_LEAD', leadId);
}
